var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    {
      attrs: {
        label: _vm.label,
        prop: _vm.prop,
        rules: _vm.rules || _vm.defaultRules,
        size: _vm.size,
      },
    },
    [
      !_vm.readonly
        ? _c("el-input", {
            attrs: {
              disabled: _vm.disabled,
              placeholder: _vm.placeholder || _vm.$t("inputText"),
              clearable: _vm.clearable,
              maxlength: "50",
            },
            nativeOn: {
              keyup: [
                function ($event) {
                  return _vm.proving($event)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleQuery.apply(null, arguments)
                },
              ],
            },
            model: {
              value: _vm.id,
              callback: function ($$v) {
                _vm.id = $$v
              },
              expression: "id",
            },
          })
        : _vm._e(),
      _vm.readonly ? _c("span", [_vm._v(_vm._s(_vm.id))]) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }